import { Box,Stack } from "@mui/material";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { ShowPassword } from "./styled.onboarding";
import { CustomButton, CustomText } from "common/Reusables";
import { useMutation } from "react-query";
import { apiErrorHandler } from "components/apiErrorHandler";
import { Helmet } from "react-helmet";
import { login } from "api/auth";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import React, { useEffect } from "react";
import styled from "styled-components";
import CustomTextField from "common/CustomTextField";
import qs from "query-string";
import * as Yup from "yup";
import SnackBar from "common/SnackBar/SnackBar";
import Loader from "components/Loader/Loader";

const Login = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const { search } = useLocation();
  const { app, logo, token, business, open } = qs.parse(search);
  const history = useHistory();

  const loginMutation = useMutation(login, {
    onSuccess: (res) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        localStorage.clear();
      }
      localStorage.setItem("access_token", res.access_token);
      localStorage.setItem(
        "business_id",
        res.user.employee_user_memberships[0].business_id
      );
      localStorage.setItem("logo", res.user.employee_user_memberships[0].logo);
      window.location.href = "/home";
    },
  });

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const business_id = localStorage.getItem("business_id");
    if (token && business_id) {
      history.replace("/home");
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (token && business) {
      logo && localStorage.setItem("logo", logo);
      token && localStorage.setItem("access_token", token);
      business && localStorage.setItem("business_id", business);
      if (open) {
        window.location.href = `/home?open=${open}`;
      } else {
        window.location.href = `/${app}`;
      }
    }
  }, [app, logo, token, business, open]);

  function handleClick(payload) {
    loginMutation.mutateAsync(payload).then((res) => res);
  }

  if (token) return <Loader />;

  return (
    <Login.Wrapper>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Log in to MyEdge</title>
        <meta property="og:title" content="Log in to MyEdge" />
        <meta
          name="description"
          content="A secure and convenient way for employees to request PTO, manage tasks, benefits, trainings and more. Sign in to access your employee self service portal."
        />
        <meta
          property="og:description"
          content="A secure and convenient way for employees to request PTO, manage tasks, benefits, trainings and more. Sign in to access your employee self service portal."
        />
      </Helmet>
      {loginMutation.isError && (
        <SnackBar severity="error">
          {apiErrorHandler(loginMutation.error)}
        </SnackBar>
      )}

      <Stack spacing={4}>
        <Stack spacing={0.5}>
          <CustomText className="text" fontWeight="bold" fontSize="30px">
            Welcome
          </CustomText>
          <CustomText
            fontSize="16px"
            fontWeight="400"
            className="text"
            color="#878787"
          >
            Sign in to your account to continue
          </CustomText>
        </Stack>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={Yup.object().shape({
            password: Yup.string().required("Required").min(8).max(128),
            email: Yup.string().email("Invalid email.").required("Required"),
          })}
          onSubmit={(values) => {
            handleClick(values);
          }}
        >
          <Form>
            <Stack spacing={2.5}>
              <div>
                <CustomTextField
                  name="email"
                  label="Email"
                  size="small"
                  inputProps={{
                    style: {
                      backgroundColor: "#F4F4F4",
                    },
                  }}
                  color="secondary"
                  placeholder="Email"
                />
              </div>
              <div
                style={{
                  position: "relative",
                }}
              >
                <CustomTextField
                  name="password"
                  label="Password"
                  size="small"
                  color="secondary"
                  inputProps={{
                    style: {
                      backgroundColor: "#F4F4F4",
                    },
                  }}
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                />
                <ShowPassword onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? "Hide" : "Show"}
                </ShowPassword>
              </div>
              <div>
                <CustomButton
                  width="100%"
                  borderRadius="5px"
                  disabled={loginMutation.isLoading}
                  // onClick={() => )}
                >
                  {loginMutation.isLoading ? "Loading..." : "Sign in"}
                </CustomButton>
              </div>
            </Stack>
          </Form>
        </Formik>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems="center"
          className="links"
        >
          <Box alignSelf={"center"}>
            <Link to="/forgot-password">Forgot Password?</Link>
          </Box>
          <Stack
            spacing={4}
            direction="row"
            justifyContent={"right"}
            className="terms"
            // marginTop="4rem"
          >
            <CustomText
              fontSize="12px"
              fontWeight="600"
              className="text"
              textAlign={"center"}
            >
              <a href="https://web.bizedgeapp.com/terms">Terms Of Use </a>
            </CustomText>

            <CustomText
              fontSize="12px"
              fontWeight="600"
              className="text"
              textAlign={"center"}
            >
              <a href="https://web.bizedgeapp.com/privacy-policy">
                Privacy Policy
              </a>
            </CustomText>
          </Stack>
        </Stack>
      </Stack>
    </Login.Wrapper>
  );
};

export default Login;

Login.Wrapper = styled(Box)`
  width: 100%;
  .links {
    margin-top: 2rem;
  }
  a {
    color: #2898a4;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }
  .terms {
    a {
      font-weight: 400;
      font-size: 13px;
      color: #000000;
    }
  }
  .text {
    text-align: left;
  }

  @media (max-width: 768px) {
    .text {
      text-align: center;
    }
  }
`;
